import type { FilterDef } from './FilterBar';

/** Whether a filter narrows the list as it stands: something typed, chosen, ticked or a period set. */
export function filterInUse(filter: FilterDef): boolean {
  switch (filter.kind) {
    case 'search':
      return filter.value.trim() !== '';
    case 'select':
      return filter.options.length > 0 && filter.value !== filter.options[0]?.value;
    case 'toggle':
      return filter.value;
    case 'dateRange':
      return filter.from !== '' || filter.to !== '';
  }
}
